import { useParams } from "react-router-dom";
import ProspectEditForm from "./components/ProspectFormEdit";
import WalletLayout from "../components/WalletLayout";
import { useConfigureFooter } from "~hooks/useHelpers";
import useClientes from "~/fetchs/useClientes";

const ProspectEdit = () => {
  const { parameter } = useParams();
  useConfigureFooter({ form: true, formId: "prospect", submitLabel: 'Atualizar' })

  return (
    <WalletLayout>
      <ProspectEditForm parameter={parameter} />
    </WalletLayout>
  );
};

export default ProspectEdit;
